import { Layout, theme } from "antd";
import React, { useState, useEffect, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DesignationApi from "../../common/Apis/DesignationApi";
import TreeChart from "./TreeChart";

const HierarchyTable = () => {
  const navigate = useNavigate();
  const { Content } = Layout;

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };
  const [Designations, setDesignations] = React.useState([]);
  const getDesignation = useCallback(() => {
    DesignationApi.ListDesignation()
      .then((response) => {
        setDesignations(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getDesignation();
    PageLoading();
  }, [getDesignation, PageLoading]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Link
            type="primary"
            to={""}
            onClick={handleGoBack}
            className="btn btn-primary btn-back"
          >
            Back
          </Link>
          <div>
            <TreeChart data={Designations} />
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default HierarchyTable;
